import React from "react";
import ShieldEmblem from "../../../icons/ShieldEmblem.svg";

const BadgesBar = () => {
  const badges = Array(5).fill(ShieldEmblem);

  return (
    <div className="flex justify-center items-center gap-[27px] w-full mt-6">
      {badges.map((badge, i) => (
        <div
          key={i}
          className="w-12 h-12 flex items-center justify-center relative animate-badgePop"
          style={{ animationDelay: `${i * 0.2}s` }} // staggered animation
        >
          {/* Badge itself */}
          <img
            src={badge}
            alt={`Badge ${i + 1}`}
            className="w-full h-full relative z-10"
          />
        </div>
      ))}

      <style>{`
        @keyframes badgePop {
          0% { transform: scale(0); opacity: 0; }
          60% { transform: scale(1.2); opacity: 1; }
          100% { transform: scale(1); }
        }
        .animate-badgePop {
          animation: badgePop 0.6s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default BadgesBar;
